var map = {
	"./box-banking.png": 4146,
	"./box-banking2.png": 5435,
	"./icon-hot.png": 7140,
	"./icon-xs.png": 8601,
	"./icon_credit.png": 614,
	"./invitation_bg.png": 4229,
	"./invite.png": 271,
	"./login-bg.png": 7156,
	"./mien-bac.png": 5573,
	"./mien-nam.png": 6280,
	"./mien-trung.png": 2810,
	"./taikhoandautu.png": 9707,
	"./tienlai.png": 7616,
	"./v1.png": 187,
	"./v10.png": 4418,
	"./v2.png": 4463,
	"./v3.png": 2959,
	"./v4.png": 9633,
	"./v5.png": 6383,
	"./v6.png": 5308,
	"./v7.png": 2450,
	"./v8.png": 4590,
	"./v9.png": 2695,
	"./win.png": 8026
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9513;